import {Component, OnInit} from '@angular/core';
import {DashboardLayersGeoBaseControlComponent} from '../dashboard-layers-geo-base-control.component';
import {debounceTime, distinctUntilChanged, filter} from 'rxjs/operators';
import {combineLatest, Observable} from 'rxjs';
import {LatLngBounds} from 'leaflet';
import {ProjectBusinessLogicFilterModel} from '../../../../shared/project-business-logic-filter/project-business-logic-filter.model';

@Component({
  selector: 'app-dashboard-layers-geo-control',
  templateUrl: '../dashboard-layers-geo-base-control.component.html',
})
export class DashboardLayersGeoControlComponent extends DashboardLayersGeoBaseControlComponent implements OnInit {

  getRefreshTrigger(): Observable<[number, LatLngBounds, ProjectBusinessLogicFilterModel]> {
    return combineLatest([
      this.mapZoom,
      this.leafletBoundaryBox.pipe(
        distinctUntilChanged((a, b) => {
          const aSW = a.getSouthWest();
          const aNE = a.getNorthEast();
          const bSW = b.getSouthWest();
          const bNE = b.getNorthEast();

          return (
            aSW.lat === bSW.lat &&
            aSW.lng === bSW.lng &&
            aNE.lat === bNE.lat &&
            aNE.lng === bNE.lng
          );
        })
      ),
      this.projectBusinessLogicSyncFilterService.getFormattedProjectBusinessLogicFilter()
    ]).pipe(
      filter(([zoom, bbox]) => !!(zoom && bbox)),
      debounceTime(500),
    ) as Observable<[number, LatLngBounds, ProjectBusinessLogicFilterModel]>;
  }

  ngOnInit() {
    super.ngOnInit();
    this.loadMapGeoData(false);
  }
}
